import React, { forwardRef, Fragment, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { Box, DialogContent, styled } from '@mui/material';
import Feed from '../feed';
import { DOMAIN } from '../../config';
import CustomizedProgressBars from '../common/loading';
import AppSnackbar from '../common/appSnackbar';
import SeriesMenuDialog from './seriesMenu';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export default function SeriesDialog({ openSeries = false, setOpenSeries, matches, chipTitle }) {
  const [latest, setLatest] = useState([]);
  const [loading, setLoading] = useState(true);
  const [empty, setEmpty] = useState(false);
  const [openSeriesMenu, setOpenSeriesMenu] = useState(false);

  const handleClose = () => setOpenSeries(false);

  // 初始加载数据
  useEffect(() => {
    if (!openSeries) return;

    setLatest([]);
    setLoading(true);
    setEmpty(false);

    fetch(`${DOMAIN}ywyminiappbot/series?classify=系列&page=1`)
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (!data || data.length === 0) {
          setEmpty(true);
        } else {
          setLatest(data);
        }
      });
  }, [openSeries]);

  return (
    <Fragment>
      <SeriesMenuDialog
        openSeriesMenu={openSeriesMenu}
        setOpenSeriesMenu={setOpenSeriesMenu}
        matches={matches}
        chipTitle={"系列菜单"}
      />

      <Dialog
        fullScreen
        open={openSeries}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppSnackbar message={"点击右上角 “选择专辑” 👆可查看全部专辑"} vertical={"bottom"} />

        {/* 毛玻璃 AppBar */}
        <AppBar sx={{
          position: 'sticky',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          backgroundColor: 'rgba(255,255,255,0.25)',
          color: '#000',
          boxShadow: 'none'
        }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
              {chipTitle}
            </Typography>
            <BlinkingButton autoFocus color="inherit" onClick={() => setOpenSeriesMenu(true)}>
              选择专辑
            </BlinkingButton>
          </Toolbar>
        </AppBar>

        <DialogContent sx={{ padding: 0, paddingTop: 45, position: 'relative' }}>
          {latest.length > 0 && (
            <Feed
              matches={matches}
              latest={latest}
              setLatest={setLatest}
              fetchUrl={`${DOMAIN}ywyminiappbot/series?classify=系列`}
              title={"系列专辑"}
              isRemark={false}
            />
          )}

          {loading && <CustomizedProgressBars />}

          {empty && (
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              flexFlow: 'row',
              padding: '200px 0',
              color: '#999'
            }}>
              <SearchOffIcon />
              <Typography variant='h6' fontSize={14}>没有此内容，我们会尽快发布...</Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}

const BlinkingButton = styled(Button)(({ theme }) => ({
  animation: 'blinking 1.8s infinite',
  '@keyframes blinking': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.7 },
    '100%': { opacity: 1 }
  },
}));
